import {ActionType} from '../actionTypes';
import {Action} from '../actions/promotionsItemsActions';
import {FlyerPageDto, FlyerPageSpotDto, PromoDto, PromoItemsDto} from "../../dtos";

export interface PageForPromoItems {
    pageIndex?: number;
    items?: PromoItemsDto[];
    promos?: PromoDto[];
}

export interface PromotionItemsState {
    activeTab: string;
    searchTerm: SearchTermForUnlinkedPromotionsItems;
    unlinkPromos: PromoDto[] | any[];
    unlinkItems: PromoItemsDto[] | any[];
    type?: string | null;
    isQualified: boolean;
    isOpenUnlinkMenu: boolean;
    isLoading?: boolean;
    error?: boolean | null;
    draggingItemRecId?: boolean | null;
    // isShowsAllItemsOfPromotions?: boolean;
    dataFromExcelFileForPromosItems: object;
    items: PromoItemsDto[];
    promos: PromoDto[];
    pages: PageForPromoItems[];
    itemsIdsForChangeQualificationLVL: number[];
    isSelectAllMode: boolean;
}

export interface SearchTermForUnlinkedPromotionsItems {
    searchTermForUnlinkedPromotions: string;
    searchTermForUnlinkedItems: string;

}


const initialState: PromotionItemsState = {
    activeTab: 'Promotions',
    searchTerm: {
        searchTermForUnlinkedPromotions: '',
        searchTermForUnlinkedItems: ''
    },
    unlinkPromos: [],
    unlinkItems: [],
    type: null,
    isQualified: false,
    isOpenUnlinkMenu: false,
    isLoading: false,
    error: null,
    draggingItemRecId: null,
    // isShowsAllItemsOfPromotions: false,
    dataFromExcelFileForPromosItems: {},
    pages: [],
    items: [],
    promos: [],
    itemsIdsForChangeQualificationLVL:[],
    isSelectAllMode: false
};

const reducer = (state: PromotionItemsState = initialState, action: Action) => {
    switch (action.type) {
        case ActionType.CHANGE_ACTIVE_TAB_NAME:
            return {...state, activeTab: action.payload, type: action.type}
        case ActionType.SET_PAGES_FOR_PROMOS_AND_ITEMS_STATE:
            let pages: PageForPromoItems[] = [];
            action.payload.forEach((page: FlyerPageDto) => {
                const pageData: PageForPromoItems = {};
                pageData.pageIndex = page.flpPageNo;
                pageData.items = [];
                pageData.promos = [];

                page.flyerPageSpots?.forEach((frame: FlyerPageSpotDto) => {
                    if(frame.flyerPromos?.length){
                        pageData.promos?.push(frame.flyerPromos[0]);

                        if(frame.flyerPromos[0]!.flyerPromoItems?.length){
                            frame.flyerPromos[0]!.flyerPromoItems.forEach((item: PromoItemsDto) => {
                                pageData.items?.push(item);
                            })
                        }
                    }

                })

                pages = [...pages, pageData];
            })

            return {
                ...state,
                pages: pages,
                // pages: action.payload.map((page: FlyerPageDto) => {
                //     return {
                //         pageIndex: page.flpPageNo,
                //     }
                // }),
                type: action.type,
            }
        case ActionType.SET_ITEMS_TO_PROMO_ITEMS_STATE:
            // const currentPageIsAlreadyExistedForItems = state.pages.find((page: PageForPromoItems) => page.pageIndex === action.payload.pageIndex);
            // if (currentPageIsAlreadyExistedForItems) {
                const newPagesStateItems = state.pages.map((page: PageForPromoItems) => {
                    if (page.pageIndex === action.payload.pageIndex) {
                        page.items = action.payload.items;
                    }
                    return page;
                })

                return {
                    ...state,
                    pages: newPagesStateItems,
                    items: action.payload.items,
                    type: action.type
                }
            // } else {
            //     return {
            //         ...state,
            //         pages: [
            //             ...state.pages,
            //             {
            //                 ...state.pages[action.payload.pageIndex],
            //                 items: action.payload.items,
            //                 pageIndex: action.payload.pageIndex
            //             }
            //         ],
            //         items: action.payload.items,
            //         type: action.type
            //     }
            //
            // }
        case ActionType.ADD_ITEMS_TO_PROMO_ITEMS_STATE:
            // const currentPageIsAlreadyExistedForItemsForAdd = state.pages.some((page: PageForPromoItems) => page.pageIndex === action.payload.pageIndex);
            // if (currentPageIsAlreadyExistedForItemsForAdd) {
                const newPagesStateWithItemsAdd = state.pages.map((page: PageForPromoItems) => {
                    if (page.pageIndex === action.payload.pageIndex) {
                        page.items = [...page.items!, ...action.payload.items]
                    }
                    return page;
                })

                return {
                    ...state,
                    pages: newPagesStateWithItemsAdd,
                    items: action.payload.items,
                    type: action.type
                }
            // } else {
            //     return {
            //         ...state,
            //         pages: [
            //             ...state.pages,
            //             {
            //                 ...state.pages[action.payload.pageIndex],
            //                 items: action.payload.items,
            //                 pageIndex: action.payload.pageIndex
            //             }
            //         ],
            //         items: action.payload.items,
            //         type: action.type
            //     }
            // }
        case ActionType.REMOVE_ITEMS_TO_PROMO_ITEMS_STATE:
            // const currentPageIsAlreadyExistedForItemsForDelete = state.pages.some((page: PageForPromoItems) => page.pageIndex === action.payload.pageIndex);
            // if (currentPageIsAlreadyExistedForItemsForDelete) {
                const newPagesStateWithItemsRemove = state.pages.map((page: PageForPromoItems) => {
                    if (page.pageIndex === action.payload.pageIndex) {
                        //remove duplicates from arrays
                        const seen = new Set();
                        const addDeletedItemsToItemsState = [...page.items!, ...action.payload.items]
                        page.items = addDeletedItemsToItemsState.filter((promo: PromoItemsDto) => {
                            const duplicate = seen.has(promo.fpiRecId);
                            seen.add(promo.fpiRecId);
                            return !duplicate;
                        });
                    }
                    return page;
                })

                return {
                    ...state,
                    pages: newPagesStateWithItemsRemove,
                    items: action.payload.items,
                    type: action.type
                }
            // } else {
            //     return {
            //         ...state,
            //         pages: [
            //             ...state.pages,
            //             {
            //                 ...state.pages[action.payload.pageIndex],
            //                 items: action.payload.items,
            //                 pageIndex: action.payload.pageIndex
            //             }
            //         ],
            //         items: action.payload.items,
            //         type: action.type
            //     }
            // }
        case ActionType.SET_PROMOS_TO_PROMO_ITEMS_STATE:
            // const currentPageIsAlreadyExistedForPromos = state.pages.find((page: PageForPromoItems) => page.pageIndex === action.payload.pageIndex);
            //
            // if (currentPageIsAlreadyExistedForPromos) {
                const newPagesStatePromos = state.pages.map((page: PageForPromoItems) => {
                    if (page.pageIndex === action.payload.pageIndex) {
                        page.promos = action.payload.promos;
                    }
                    return page;
                })

                return {
                    ...state,
                    pages: newPagesStatePromos,
                    promos: action.payload.promos,
                    type: action.type
                }
            // } else {
            //     return {
            //         ...state,
            //         pages: [
            //             ...state.pages,
            //             {
            //                 ...state.pages[action.payload.pageIndex],
            //                 promo: action.payload.promos,
            //                 pageIndex: action.payload.pageIndex
            //             }
            //         ],
            //         promos: action.payload.promos,
            //         type: action.type
            //     }
            //
            // }

        case ActionType.CHANGE_SEARCH_TERM:
            return {...state, searchTerm: action.payload, type: action.type}
        case ActionType.SAVE_PROMO_ITEMS_FILE_IN_STATE:
            return {...state, dataFromExcelFileForPromosItems: action.payload, type: action.type}
        case ActionType.ADD_PROMOS_TO_UNLINK_PROMOS:
            if (action.payload.isReplace) {
                return {
                    ...state,
                    unlinkPromos: [...action.payload.newState],
                    type: ActionType.ADD_PROMOS_TO_UNLINK_PROMOS
                }
            } else {
                return {
                    ...state,
                    unlinkPromos: [...action.payload.newState, ...state.unlinkPromos],
                    type: ActionType.ADD_PROMOS_TO_UNLINK_PROMOS
                }
            }

        case ActionType.ADD_ITEMS_TO_UNLINK_ITEMS:
            const itemsWithIndex = action.payload.newState.map((key: PromoItemsDto, index: number) => {
                key.index = index;
                key.isLastSelected = false;
                return key;
            });
            if (action.payload.isReplace) {
                return {...state, unlinkItems: [...itemsWithIndex], type: action.type}
            } else {
                return {
                    ...state,
                    unlinkItems: [...itemsWithIndex, ...state.unlinkItems],
                    type: action.type
                }
            }

        case ActionType.DELETE_PROMOS_FROM_UNLINK_PROMOS:
            return {...state, unlinkPromos: action.payload, type: action.type}

        case ActionType.DELETE_ITEMS_FROM_UNLINK_ITEMS:
            return {...state, unlinkItems: action.payload, type: action.type}

        case ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU:
            return {...state, unlinkItems: [], unlinkPromos: [], type: action.type}

        case ActionType.TOGGLE_UNLINK_PANEL:
            return {...state, isOpenUnlinkMenu: action.payload, type: action.type}

        case ActionType.CHANGE_QUALIFIED_STATUS_FOR_PROMOTIONS_AND_ITEMS:
            return {
                ...state,
                isQualified: action.payload,
                type: action.type
            }
        case ActionType.CHANGE_SELECT_ALL_STATUS_FOR_PROMOTIONS_AND_ITEMS:
            return {
                ...state,
                isSelectAllMode: action.payload,
                type: action.type
            }

        case ActionType.ATTACH_PROMO_TO_FLYER_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.ATTACH_PROMO_TO_FLYER_SUCCESS:
        case ActionType.ATTACH_PROMO_TO_FLYER_DND_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.ATTACH_PROMO_TO_FLYER_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.ATTACH_PROMO_TO_FLYER_COMPLETE:
        case ActionType.ATTACH_PROMO_TO_FLYER_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.ATTACH_ITEMS_TO_FLYER_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.ATTACH_ITEMS_TO_FLYER_SUCCESS:
            // case ActionType.ATTACH_ITEMS_TO_FLYER_DND_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.ATTACH_ITEMS_TO_FLYER_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.ATTACH_ITEMS_TO_FLYER_COMPLETE:
            // case ActionType.ATTACH_ITEMS_TO_FLYER_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.ATTACH_PROMO_TO_FRAME_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.ATTACH_PROMO_TO_FRAME_SUCCESS:
        case ActionType.ATTACH_PROMO_TO_FRAME_DND_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.ATTACH_PROMO_TO_FRAME_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.ATTACH_PROMO_TO_FRAME_COMPLETE:
        case ActionType.ATTACH_PROMO_TO_FRAME_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.ATTACH_ITEM_TO_PROMO_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.ATTACH_ITEM_TO_PROMO_SUCCESS:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.ATTACH_ITEM_TO_PROMO_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.ATTACH_ITEM_TO_PROMO_COMPLETE:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        // post image to item
        case ActionType.POST_IMAGE_TO_ITEM_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.POST_IMAGE_TO_ITEM_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.POST_IMAGE_TO_ITEM_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.POST_IMAGE_TO_ITEM_COMPLETED:
            return {...state, error: null, isLoading: false, type: action.type};
        // change qualification lvl for promos
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_START:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_SUCCESS:
            return {...state, itemsIdsForChangeQualificationLVL: action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_ITEMS_COMPLETED:
            return {...state, error: null, isLoading: false, type: action.type};
        // change qualification lvl for promos
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_START:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.CHANGE_QUALIFICATION_LVL_FOR_PROMOS_COMPLETED:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.UPDATE_ITEM_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.UPDATE_ITEM_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.UPDATE_ITEM_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.UPDATE_ITEM_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.EDIT_PROMOTION_ITEM_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.EDIT_PROMOTION_ITEM_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.EDIT_PROMOTION_ITEM_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.EDIT_PROMOTION_ITEM_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.CREATE_PROMOTION_ITEM_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.CREATE_PROMOTION_ITEM_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.CREATE_PROMOTION_ITEM_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.CREATE_PROMOTION_ITEM_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.CREATE_ITEM_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.CREATE_ITEM_SUCCESS:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.CREATE_ITEM_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.CREATE_ITEM_COMPLETE:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.UPDATE_PROMOTION_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.UPDATE_PROMOTION_SUCCESS:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.UPDATE_PROMOTION_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.UPDATE_PROMOTION_COMPLETE:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.CREATE_PROMOTION_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.CREATE_PROMOTION_SUCCESS:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_SUCCESS:
            return {...state, error: null, isLoading: false, type: action.type};
        case ActionType.CREATE_PROMOTION_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.CREATE_PROMOTION_COMPLETE:
            // case ActionType.ATTACH_PROMO_TO_FRAME_DND_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};


        case ActionType.DELETE_PROMO_FROM_FLYER_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.DELETE_PROMO_FROM_FLYER_SUCCESS:
        case ActionType.DELETE_PROMO_WITH_ITEMS_FROM_FLYER_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.DELETE_PROMO_FROM_FLYER_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.DELETE_PROMO_FROM_FLYER_COMPLETE:
        case ActionType.DELETE_PROMO_WITH_ITEMS_FROM_FLYER_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.DELETE_ITEMS_FROM_FLYER_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.DELETE_ITEMS_FROM_FLYER_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.DELETE_ITEMS_FROM_FLYER_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.DELETE_ITEMS_FROM_FLYER_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.DELETE_IMAGE_FROM_ITEM_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.DELETE_IMAGE_FROM_ITEM_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.DELETE_IMAGE_FROM_ITEM_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.DELETE_IMAGE_FROM_ITEM_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.DELETE_IMAGE_FROM_PROMOTION_START:
            return {...state, error: null, isLoading: true, type: action.type};
        case ActionType.DELETE_IMAGE_FROM_PROMOTION_SUCCESS:
            return {...state, ...action.payload, error: null, isLoading: false, type: action.type};
        case ActionType.DELETE_IMAGE_FROM_PROMOTION_ERROR:
            return {...state, error: action.payload, isLoading: false, type: action.type};
        case ActionType.DELETE_IMAGE_FROM_PROMOTION_COMPLETE:
            return {...state, error: null, isLoading: false, type: action.type};

        case ActionType.CHANGE_DRAGGING_ITEM_RECID:
            return {...state, draggingItemRecId: action.payload}
        // case ActionType.SHOW_HIDE_ALL_ITEMS_IN_ALL_PROMOTIONS:
        //     return {...state, isShowsAllItemsOfPromotions: action.payload}
        default:
            return state;
    }
}

export default reducer;